import { LocalStorage } from "quasar"
import { api } from "./axios"
import store from "@/store"

export default async () => {
  const token = LocalStorage.getItem('auth._token')
  if (token) {
    try {
      const resp = await api.get('/mentor/profile/', { headers: {Authorization: `Token ${token}`}})
      api.defaults.headers.common['Authorization'] = `Token ${token}`

      store.dispatch('auth/setLogin', resp.data)
    } catch (error) {
      console.log(error)
      LocalStorage.remove('auth._token')
    }
  }
}
